import React, { Component } from 'react';

import './Compromisso.scss';

import renderHTML from 'react-render-html';
import Fade from 'react-reveal/Fade';

class Compromisso extends Component {

	constructor() {
        super();
	}

    componentDidMount() {
    }

    componentWillUnount() {
    }

	render() {
        let itemClasses = [
            'row',
            'compromisso',
            'compromisso--' + this.props.slug
        ];

        let icon = (this.props.icon) ? <div className="compromisso__icon">
                                <img src={ this.props.icon } />
                            </div> : '';

        let text = (this.props.text) ? <p>{ renderHTML( this.props.text ) }</p> : '';
        let subtitle = (this.props.subtitle) ? <h3 className="compromisso__subtitle">{ renderHTML(this.props.subtitle) }</h3> : '';

        let children = (this.props.children) ? this.props.children : '';

        return (

            <div className={ itemClasses.join(' ') }>
                <div className="compromisso__bg"><img src={ this.props.icon } /></div>
                <div className="container">
                    <div className="column column--half">
                        <Fade bottom>
                            <h2 className="compromisso__title">{ renderHTML(this.props.title) }</h2>
                            { subtitle }
                        </Fade>
                    </div>
                    <div className="column column--half">
                        <Fade bottom>
                            { icon }
                            { text }
                            { children }
                        </Fade>
                    </div>
                </div>
            </div>
    	);
	}
}

export { Compromisso };